module.exports = function() {
  return new Worker(__webpack_public_path__ + "4d16af3758df21128816.worker.js");
};